export default __webpack_public_path__ + "static/media/Bhairavnath-Statue.c025d4e6.jpg";